{
    "Section_Header": "Send to me and:",
    "Section_SubHeader": "Additional Recipients:",
    "Validation_Valid_Domain_Name": "Email must be valid",
    "Validation_Valid_Same_As_User": "Email must be within the same domain as the current user",
    "Validation_Valid_Non_Blacklisted_Email": "Email must not be within a blacklisted domain",
    "Validation_Valid_Max_Custom_Domains": "You can only add a maxmimum of {} custom emails",
    "Validation_Valid_Max_Entries": "You cannot have more then {} emails",
    "NAME": "ReportSchedulingEmails"
}
